import BlogLandingPage from '../components/BlogArticles/components/BlogLandingPage';
import { blogArticles } from '../public-content-manifest';
import { publicMeta } from './public-meta';

export const meta = publicMeta(
  'Blog | Cartwheel',
  'Notes from the team building Cartwheel.',
);

export default function BlogRoute() {
  return <BlogLandingPage articles={[...blogArticles]} />;
}
